<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择账户"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :noSearch="true"
      @show="sub"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  companyPlatformAccountList,
} from 'api/getPay';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      showName: 'custName',
      tableSelectTar: 'acctNo',
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
      ],
      tableTitle: [
        {
          prop: 'custName',
          label: '账户姓名',
        },
        {
          prop: 'acctNo',
          label: '银行账号',
        },
        {
          prop: 'receBankBalance',
          label: '收款私户(元)',
        },
        {
          prop: 'payBankBalance',
          label: '付款私户(元)',
        },
        {
          prop: 'payUnDoBalance',
          label: '已付未提现(元)',
        },
      ],
    };
  },
  methods: {
    getListApi: companyPlatformAccountList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    sub () {
      this.$refs.chooseTmpl.sub({
        bankType: this.type === 'public' ? 111 : 222,
        isNeedHa: 0,
        userType: 6,
      });
    },
    show () {
      console.log('show');
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
